"use client"

import { useEffect, useState } from "react"
import { getBriefings, getUserId } from "../API"
import { countUnread } from "./briefingNotifications"

// Usado pra mostrar o "badge" de notificação (tipo WhatsApp) no botão que
// abre a tela de Briefings. Só conta briefings em que o usuário atual é o
// vendedor que criou ou o designer responsável — não notifica sobre
// briefings de outras pessoas.
export function useBriefingNotifications(pollMs = 60000) {
    const [count, setCount] = useState(0)

    useEffect(() => {
        let active = true
        const myId = getUserId()

        const load = async () => {
            const all = await getBriefings({})
            if (!active) return
            const relevant = (all || []).filter((b: any) => b.created_by === myId || b.designer_id === myId)
            setCount(countUnread(relevant))
        }

        load()
        const interval = setInterval(load, pollMs)
        return () => { active = false; clearInterval(interval) }
    }, [])

    return count
}
